import script from "./FreightInfoButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./FreightInfoButton.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__